import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static targets = ["content"]
  static values = { url: String }

  connect() {
    this.loadingHtml = this.contentTarget.innerHTML
    $(this.element).on('show.bs.modal', this.load)
  }

  disconnect() {
    $(this.element).off('show.bs.modal', this.load)
  }

  load = () => {
    this.contentTarget.innerHTML = this.loadingHtml

    fetch(this.urlValue)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load modal content from ${this.urlValue} (status ${response.status})`)
        }
        return response.text()
      })
      .then(html => {
        this.contentTarget.innerHTML = html
        $(this.contentTarget).find('[data-toggle="tooltip"]').tooltip()
      })
      .catch(error => {
        if (error.name === "AbortError") { return }
        if (window.newrelic) { window.newrelic.noticeError(error) }
        this.contentTarget.innerHTML = '<div class="alert alert-danger">Failed to load content. Please try again.</div>'
      })
  }
}
